import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ContactsComponent } from './contacts/contacts.component';
import { SharedModule } from '../shared/shared.module';
import { ContactComponent } from './contact/contact.component';
import { AttachmentsComponent } from '../shared/attachments/attachments.component';



@NgModule({
  declarations: [
    ContactComponent,
    ContactsComponent
  ],
  imports: [
    CommonModule,
    SharedModule,
    AttachmentsComponent
  ]
})
export class ContactModule { }
